<template>
     <div class="publicViewClass" style="padding-top:0">
          <div class="edit-step">
            <topicSteps :active = "1" :propList="propList"></topicSteps>
        </div> 
         <div id="editPaper" class="app-inner">
            <div class="public-btn-small flex align-cen posta">
            <div class="public-btn-small-plan"  style="margin-left:0" @click="$util.reback('/Course')">
            返回
            </div>
           <el-button type="primary"  :loading="loading" class="public-btn-small-primary public-btn-small-load" style="margin-left:16px"
           @click="openSteps('ruleForm')"
            >
             下一步
           </el-button>
            </div>
            <div class="edit-from">
             <div class="public-tit flex align-cen">
                    <div class="public-tit-list">
                        <i class="icon-al-database-fill"></i>  基本信息
                    </div>
              </div>
               <el-form ref="ruleForm" :model="form" label-width="150px" :rules="rules" class="flex align-cen">
                  <el-form-item label="课程标题：" prop="title">
                    <el-input v-model="form.title" placeholder="请输入您的课程标题【1-50】" clearable></el-input>
             </el-form-item>
              <el-form-item label="课程分类：" prop="classifyId">
                    <el-select v-model="form.classifyId" placeholder="选择课程分类">
                        <el-option
                        v-for="item in options"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                    <el-form-item label="课程封面：" prop="logo">
                    <el-upload
                    class="avatar-uploader"
                    :action="$config.baseUrl + '/admin/sys-file/upload'"
                    :headers="headers"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess"
                    :before-upload="$util.beforeUpload"
                    :disabled="uploadBoolean"
                    >
                    <div slot="tip" class="el-upload__tip" >建议尺寸：<span style="color:#f56c6c">373*280</span></div>
                    <img :src="form.logo" class="avatar" v-if="form.logo">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                       <!--页面新增删除和预览-->
                    <span v-if="form.logo" class="el-upload-list__item-actions">
                        <span class="upload-icon">
                            <span class="el-uploads-span" style="margin-right: 10px;" @click.stop="oploadImgPre">
                                <i class="el-icon-zoom-in"></i>
                            </span>
                            <span class="el-upload-span" @click.stop="oploadImgDel">
                                <i class="el-icon-delete"></i>
                            </span>
                        </span>
                    </span>
                    <el-dialog :visible.sync="oploadDialogVisible" size="tiny" :append-to-body="true" :show-close="false">
                        <img width="100%" :src="form.logo" alt="">
                    </el-dialog>
                    </el-upload>
                 </el-form-item>
                 <el-form-item label="推荐状态：">
                    <el-radio v-model="form.recommend" label="0">未推荐</el-radio>
                    <el-radio v-model="form.recommend" label="1">推荐</el-radio>
                </el-form-item>
                <el-form-item label="排序：" >
                    <el-input v-model="form.sort" placeholder="请输入排序" clearable></el-input>
                 </el-form-item>
                   <el-form-item label="课程简介：">
                        <el-input
                        type="textarea"
                        placeholder="请输入课程简介 限制500字"
                        v-model="form.introduction"
                        maxlength="500"
                        show-word-limit
                        rows="5"
                        >
                        </el-input>
                </el-form-item>
               </el-form>
                <div class="public-tit flex align-cen">
            <div class="public-tit-list">
                <i class="icon-al-database-fill"></i>  规格信息
            </div>
        </div>
        <el-form ref="ruleForm2" :model="form" label-width="140px" :rules="rules">
                <el-form-item label="付费类型：" prop="payType">
                <el-radio v-model="form.payType" label="1"  >免费</el-radio>
                <el-radio v-model="form.payType" label="2" >付费</el-radio>
              </el-form-item>
                    <el-form-item label="付费模式：" :prop="form.payType == 2 ? 'payModel' : ''"  v-if="form.payType == 2">
                <el-radio v-model="form.payModel" label="1"  @change="priceChange">时长制</el-radio>
              </el-form-item> 
                            <!-- 选择时长制 -->
              <div class="el-price-table flex align-cen" v-if="form.payType == 2 && form.payModel == 1">
                <div class="table-label">时长制售价规格：</div>
                 <div class="table-con" style="margin-bottom:20px">
                        <el-table
                      :data="form.skuList"
                      border
                      style="width: 100%"
                      >
                      <el-table-column label="套餐名称" align="center" width="220px">
                        <template slot-scope="scope">
                          <el-input v-model="scope.row.name" placeholder="请输入套餐名称【1-30】" clearable
                          maxlength="30"
                          minlength="1"
                          >
                          </el-input>
                        </template>
                       </el-table-column>
                       <el-table-column label="使用期限（月）" align="center" width="170px"
                       >
                        <template slot-scope="scope">
                          <el-input v-model="scope.row.deadline" placeholder="请输入使用期限" clearable
                           maxlength="4"
                           minlength="1"
                          ></el-input>
                        </template>
                       </el-table-column>
                        <el-table-column label="支撑账号个数" align="center" width="200px"
                        >
                        <template slot-scope="scope">
                          <el-input v-model="scope.row.accountNum" placeholder="不输则视为无限制" clearable
                          oninput="value=value.replace(/[^\d]/g,'')"
                           maxlength="5"
                           minlength="1"
                          ></el-input>
                        </template>
                       </el-table-column>
                       <el-table-column label="原价（元）" align="center" width="150px">
                        <template slot-scope="scope">
                          <el-input v-model="scope.row.originalPrice" placeholder="请输入原价" clearable
                           oninput="value=value.replace(/^[^\d.]+/g,'')"
                          maxlength="9"
                          minlength="1"
                          ></el-input>
                        </template>
                       </el-table-column>
                        <el-table-column label="现价（元）" align="center" width="150px">
                        <template slot-scope="scope">
                          <el-input v-model="scope.row.salePrice" placeholder="请输入现价" clearable
                           oninput="value=value.replace(/^[^\d.]+/g,'')"
                           maxlength="9"
                          minlength="1"
                          ></el-input>
                        </template>
                       </el-table-column>
                       <el-table-column label="操作" align="center" width="150px">
                        <template slot-scope="scope">
                         <el-button type="text" size="small" style="color:red" @click.stop="deltab(scope.row)">删除</el-button>
                        </template>
                       </el-table-column>
                        </el-table>
                     <div class="addtab">
                     <div class="public-btn-small" style="padding:0;width:140px;margin-top:20px">
                     <div class="public-btn-small-primary" @click="addtab">
                          添加规格        
                    </div>
                </div>
                  </div> 
                  </div>
              </div>
        </el-form>
                               <div class="public-tit flex align-cen">
            <div class="public-tit-list">
                <i class="icon-al-database-fill"></i>  关联试卷
            </div>
                <div class="mft public-btn-small">
                     <div class="public-btn-small-primary" @click="openBl">
                          关联相关试卷       
                    </div>
                </div>
        </div>
                <!-- 关联试卷 -->
         <div class="App-tab">
         <el-table
            :data="relationList"
            border
            style="width: 100%"
            :header-cell-style="{background:'#f7f8fa',color:'#333'}"
            >
            <el-table-column label="试卷封面" align="center">
              <template slot-scope="scope" >
                <img :src="scope.row.logo ? scope.row.logo : require('../../../assets/images/nullimg.png')" alt="" style="display: block;width:50%;margin:0 auto" v-if="scope.row.id !=0"> 
            </template>
            </el-table-column>
             <el-table-column :prop=" isShowId ? 'paperId' : 'id'" label="试卷ID" align="center" width="200">
          </el-table-column>
             <el-table-column prop="paperName" label="试卷名称" align="center" width="300">
          </el-table-column>
               <el-table-column prop="classifyName" label="试卷分类" align="center" >
          </el-table-column>
           <el-table-column prop="examNum" label="考试人次" align="center" >
          </el-table-column>
            <el-table-column prop="" label="考试时间" align="center" >
             <template slot-scope="scope">
              <div>
                {{scope.row.answerTimeLimit ? `${scope.row.answerTimeLimit}分钟` : '-'}}
              </div>
             </template>
          </el-table-column>
            <el-table-column prop="questionNum" label="题目数" align="center" >
          </el-table-column>
            <el-table-column prop="practiceMode" label="练习试卷" align="center" >
                    <template slot-scope="scope">
              <div>
                {{scope.row.practiceMode == 1 || scope.row.practiceMode == 2 ? '是' : '否'}} 
              </div>
             </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            align="center"
            >
             <template slot-scope="scope">
            <el-button type="text" size="small" style="color:red" @click.stop="deletPro(scope.row)">取消关联</el-button>
             </template>
             </el-table-column>
         </el-table>
         </div>
            <div class="public-tit flex align-cen" id="addCanvas" v-if="platformAppContentList.length == 0">
            <div class="public-tit-list">
                <i class="icon-al-database-fill"></i>  课程详情
            </div>
               <div class="mft public-btn-small">
                     <div class="public-btn-small-primary"
                     @click="addCanvas(-1)"
                     >
                          添加分类  
                    </div>
                </div>
              </div>
              <div class="AppContent">
                  <div class="moreCanvas"
                     v-for="(item,index) in platformAppContentList"
                    :key="index"
                    :id="'addCanvas'+index"
                    >
                     <div class="public-tit flex align-cen" style="margin-bottom:20px">
                        <div class="public-tit-list">
                            <i class="icon-al-database-fill"></i> 分类{{index+1}}
                        </div>
                    </div>
                     <div class="businessList-filter-list flex align-cen">
                            <div class="fl-le flex align-cen">
                    <div class="label">分类标题：</div>
                    <div class="el-select1">
                        <el-input placeholder="请输入分类标题【1-5】" v-model="item.title" clearable
                        maxlength="5"
                        > </el-input>
                    </div>
                    </div>
                       <div class="fl-rt flex align-cen">
                    <div class="label">副标题：</div>
                    <div class="el-select1">
                    <el-input placeholder="请输入副标题【1-50】" v-model="item.subhead" clearable maxlength="50"> </el-input>
                    </div>
                    </div>
                       <div class="mft deletBtn"
                    @click="deletCanvas(item)"
                    >
                    删除分类
                    </div>
                    <div class="mft public-btn-small" style="padding-left:0" v-if="index == platformAppContentList.length-1">
                     <div class="public-btn-small-primary"
                     @click="addCanvas(index+1)"
                     >
                          添加分类  
                    </div>
                </div>
                     </div>
                           <div class="quillsFLex flex align-cen">
              <quillsTemplate  @sendStatus="emitFun" :propData="item.content"
                      :currindex="index"
                    :ref="'quillTemplate' + index"
                    :placeName="'电脑端富文本'"
                    ></quillsTemplate>
                     <quillsTemplate  @sendStatus="emitFun1" :propData="item.mobileContent"
                      :currindex="index"
                    :ref="'quillTemplate1' + index"
                     :placeName="'移动端富文本'"
                    ></quillsTemplate>
                </div>
                  </div>
               </div>
            </div>
         </div>
 <!-- 选择试卷弹框 -->
     <el-dialog
  title="选择相关试卷"
  :visible.sync="centerDialogVisible"
  width="80%"
  :append-to-body="true"
  center
  v-if="centerDialogVisible"
   @close="reback1"
  >
  <div class="forminfo"> 
    <paperTemplate :selectType='centerDialogVisible'
    :importName="'course'"
    :isAppId="isShowId"
    @sendStatus="classSelect"
    ref="paperTemplate"
    ></paperTemplate>
       <div class="authbtn flex align-cen">
             <el-button plain @click="reback1">取消</el-button>
              <el-button type="primary" class="mft" @click="onSubmit1">确认选择</el-button>
        </div>
  </div>
     </el-dialog>
     </div>
</template>
<script>
import {getAllCourseClassify,addCourse,deletCourse} from "@/api/index/index"  //课程分类、新增课程、课程详情
import topicSteps from "@/components/topicSteps/index.vue"; //步骤条组件
import CropperImage from "@/components/CropperImage.vue";  //裁剪组件
import quillsTemplate from "@/components/quills";  //多富文本组件
import paperTemplate from "@/views/testPaper/testPapeList/index.vue"; //将试卷列表页面作为组件使用
export default {
    name:'addCourse',
    components: {
        topicSteps,
        CropperImage,
        quillsTemplate,
        paperTemplate
    },
    data() {
        return {
        isShowId:false,
        centerDialogVisible: false,
        relationList:[],
        selectList:[],
        nowIndex:0,
        platformAppContentList:[],
        platformAppRelationList:[],
        oploadDialogVisible:false,
        uploadBoolean:false,
        headers:{},
        loading:false,
        options:[],
        form:{
            title:'',
            classifyId:'',
            logo:'',
            recommend:'0',
            sort:'',
            introduction:'', 
            payType:'',
            payModel:'',
            skuList:[]
        },
        rules:{
             title: [{ required: true, message: '请输入您的课程标题', trigger: 'blur' },
             { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
             ],
             classifyId: [{ required: true, message: '请选择课程分类', trigger: 'change' }],
             logo:[{ required: true, message: '请上传课程封面图', trigger: 'blur' }],
               payType:[{ required: true, message: '请选择付费类型', trigger: 'blur' }],
                 payModel:[{ required: true, message: '请选择付费模式', trigger: 'blur' }],
        },
         propList:[
            {
                steps:1,
                text:'基本信息',
            },
            {
                steps:2,
                text:'章节编辑',
            },{
                steps:3,
                text:'上传课件',
            },{
                steps:4,
                text:'完成', 
            }

        ]
        }
    },
    created () {
        this.getCourseClass()
        let token = this.$locaStorage.setAge().get('token')
        if(token){
            this.headers = {
                'Authorization': token
            }
        }
        if(this.$route.query.id) this.getDetail()
    },
    methods: {
    //   课程详情
    getDetail(){
        deletCourse(
                {id:this.$route.query.id},
                'get')
            .then(res =>{
                 this.form = {
                    title:res.data.title,
                    classifyId:res.data.classifyId,
                    logo:res.data.logo,
                    recommend:res.data.recommend,
                    introduction:res.data.introduction,
                    sort:res.data.sort,
                    payType:res.data.payType,
                    payModel:res.data.payModel,
                    skuList:res.data.skuList ? res.data.skuList : [{ name:'', originalPrice:'', salePrice:'',deadline:'',accountNum:''}]
                }
                this.isShowId = true
                this.platformAppContentList = res.data.contentList
                this.relationList = res.data.paperList
            })
            .catch(err => {})
    },
          // 添加规格
      addtab(){
        if(this.form.skuList.length > 4){
          return this.$message.error('最多只能添加5个')
        }else{
           this.form.skuList.push({
          name:'',
          originalPrice:'',
          salePrice:'',
          deadline:'',
          accountNum:'',
        })
        }
      },
      // 规格删除
      deltab(data){
           let arr = []
          arr.push(data)
        let delet= this.form.skuList.filter(item=>!arr.some(ele=>ele===item)) 
        if(this.form.skuList.length == 1){
          this.$message.error('需保留一个')
        }else{
          this.form.skuList= delet
        }
         
      },
           // 付费模式改变
      priceChange(){
        if(this.form.payModel == 2){
          this.form.skuList = []
        }
      },
         deletPro(data){
              let arr = []
            arr.push(data)
        let delet= this.relationList.filter(item=>!arr.some(ele=>ele.id===item.id)) 
         this.relationList = delet
        //   this.$refs.appTemplate.editfun(this.relationList) 
        },
         // 应用列表取消选择
        reback1(){
            this.$refs.paperTemplate.remove()  
             if(this.$route.query.id) this.isShowId = true
             this.centerDialogVisible = false  
        },
        // 应用列表确认选择
         onSubmit1(){
           // 过滤数组中的对象，去除重复项  
                let uniqueObjects = this.selectList.filter((item, index) => {  
                  // 如果是对象，则进行去重逻辑  
                  if (typeof item === 'object' && item !== null) {  
                    // 使用 findIndex 查找数组中是否存在相同的对象  
                    return this.selectList.findIndex(otherItem => JSON.stringify(item) === JSON.stringify(otherItem)) === index;  
                  }  
                  // 如果不是对象，则直接返回 true，因为非对象元素不会重复  
                  return true;  
                });  
            this.relationList = uniqueObjects
           this.centerDialogVisible = false
        },
             classSelect(val,val1){
            this.selectList = val
            this.isShowId = val1
        },
         // 打开试卷列表
          openBl(){
             this.centerDialogVisible = true     
                     this.$nextTick(function () {   
                        this.$refs.paperTemplate.editfun(this.relationList)    
                    })
           
        },
               // 子组件触发的方法
        emitFun(val,index){
            this.platformAppContentList[index].content = val
        },
            emitFun1(val,index){
            this.platformAppContentList[index].mobileContent = val
        },

              // 删除分类
        deletCanvas(data){
            let arr = []
            arr.push(data)
        let delet= this.platformAppContentList.filter(item=>!arr.some(ele=>ele ===item)) 
       this.platformAppContentList = delet
        this.nowIndex == 0 ?  this.nowIndex = 0 : this.nowIndex = this.nowIndex -1
        },
                 // 添加分类
        addCanvas(index){
            if(index>=0){
                this.nowIndex=index
            }else{
                this.nowIndex=0
            }
            this.platformAppContentList.push({
                title:'',
                subhead:'',
                content:'',
                mobileContent:''
            })
        },
             // 获取分类
        getCourseClass(){
            this.options = []
             getAllCourseClassify({
                name:''
             })
            .then(res => {
              if(res.data){
               this.options = res.data
              }else{
                    this.options = []
             }

            })
            .catch(err => {
            })
        },
        // 下一步
         openSteps(formName){
              this.platformAppRelationList = []
            for (const key in this.relationList) {
                this.platformAppRelationList.push(
                     {
                        paperId:!this.isShowId ? this.relationList[key].id : this.relationList[key].paperId
                    }
                )
            }
             let params = { ...this.form};
            let method = "post"
            let appSkuList = this.form.skuList
            if(!this.$route.query.id) params = {...params,contentList:this.platformAppContentList,paperList:this.platformAppRelationList},method = "post";
            if(this.$route.query.id) params = {...params,id:this.$route.query.id,contentList:this.platformAppContentList,paperList:this.platformAppRelationList},method = "put";
             this.$refs[formName].validate((valid) => { 
                this.$refs['ruleForm2'].validate((valid2) => {
                      if(valid){
                      if(valid2){
                         if(this.form.payModel == 1 && this.form.payType == 2){
                            for (const key in appSkuList) {
                            if(!appSkuList[key].name || !appSkuList[key].originalPrice || !appSkuList[key].salePrice || !appSkuList[key].deadline){
                                setTimeout( () => {this.$message.error('请补全第' + (parseInt(Number(key)) + 1) + '条规格信息')}, 10)
                                return 
                            }
                            }
                         }
                     this.commentBness(params,method)
                      }
                }
                })
              })
         },
        //  新增修改公共方法
                  commentBness(params,method){
               this.loading = true
                addCourse(params,method)
                        .then(res => {
                           if(res.code == 0){
                            this.loading = false
                            if(!this.$route.query.id)  this.$util.Notifi('新增成功','success','fa-check'); 
                           if(this.$route.query.id) this.$util.Notifi('修改成功','success','fa-check');
                          this.nextId = res.data.id; 
                                setTimeout(() => {
                           this.$router.push({
                            name:'twoCourse',
                            query:{
                                twoId:this.$route.query.id || this.nextId
                            }
                           })
                             }, 100);
                           }else{
                             this.loading = false
                            this.$util.Notifi(res.msg,'error','fa-exclamation-circle');
                           }
                        })
                        .catch(err => {
                           this.loading = false
                        })
        },
              // 图片放大
         oploadImgPre(){
            this.oploadDialogVisible = true
            },
        oploadImgDel(){
            this.form.logo = ''
                let _this= this
                setTimeout(function(){
                    _this.uploadBoolean = false
                },1000)
        },
         handleAvatarSuccess(res, file) {
        this.form.logo = res.data.url
        
        if(this.form.pic){
        this.uploadBoolean = true
         }
      },
         
    },
}
</script>
<style lang="scss" scoped>
   .edit-from{
         margin-bottom: 44px;
         .edit-from-tit{
             background: rgb(215, 215, 215);
             padding: 10px 20px;
             font-size: 18px;
         }
           .el-form{
            flex-wrap: wrap;
            margin-top: 20px;
         .el-form-item{
            width: 50%;
        .el-input,.el-cascader{
            width: 80%;
        }
        .el-select,.el-input-group{
            width: 80%;
        }
        .el-textarea{
            width: 80%;
        }
        
        }
         }
         .App-tab{
            margin: 20px 0;
            
        }
         }
                      .AppContent{
        margin: 20px 0;
        margin-bottom: 100px;
        position: relative;
        .moreCanvas{
            margin-top: 60px;
        }
        .moreCanvas:first-child{
            margin-top: 0;
        }
           .el-select1{
                width: 80%;
            }
        .fl-le{
            width: 40%;
        }
        .fl-rt {
             width: 40%;
        padding-left: 30px;
      }
      .deletBtn{
        margin-left: 30px;
        height: 32px;
        line-height: 30px;
        font-size: 14px;
        padding: 0 16px;
        border-radius: 2px;
        font-family: inherit;
        border-width: 1px;
        border-style: solid;
        text-align: center;
        vertical-align: middle;
        box-sizing: border-box;
        cursor: pointer;
        transition: all 0.3s;
        background: #f56c6c;
        color: #fff;
      }
      .el-input,.el-cascader{
            width: 100%;
        }
     }
           ::v-deep{
                            .quillsFLex{
      .quillTemplate{
        margin-right: 10px !important;
      }
    }
 .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 80px;
    height: 80px;
    line-height: 80px;
    text-align: center;
  }
  
  .avatar {
    width: 371px;
    height: 130px;
    display: block;
  }
  .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 200px;
        height: 200px;
        line-height: 200px;
        text-align: center;
    }
   .upload-icon {
        position: absolute;
        top: 50%;
        margin-left: -28px;
        margin-top: -18px;
    }
    .uploadPicture{
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 50px;
        background: rgba(0,0,0,.6);
        color: #fff;
        line-height: 50px;
        text-align: center;
    }
    .el-dialog{
        width: 50%;
    }
  }
</style>